import { useToast } from "@/components/ui/use-toast";
import { Module } from "@/constants";
import { ContractorVisitsService } from "@/modules/projects/services/contractorVisits";
import { ApiError } from "@/services/api";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import {
  CreateContractorVisit,
  ReadContractorVisit,
} from "@/types/contractorVisit";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const useCreateContractorVisitsMutation = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutationWithErrorHandling<
    ReadContractorVisit,
    ApiError,
    CreateContractorVisit,
    unknown
  >({
    mutationFn: (values: CreateContractorVisit) =>
      ContractorVisitsService.post(values),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [Module.ContractorVisits],
      });
      toast({
        title: t("projectContractorVisits.success.create"),
      });
    },
    errorTitle: t("projectContractorVisits.errors.create"),
  });
};
